import Diversity2Icon from "@mui/icons-material/Diversity2";
import HandshakeIcon from "@mui/icons-material/Handshake";
import NewspaperIcon from "@mui/icons-material/Newspaper";

const currentYear = new Date().getFullYear();

export const dataSources = {
  political: {
    label: "Electoral & Legislative",
    value: "political",
    description: [
      <>
        Member political work that counts toward the{" "}
        <strong>1.5% member activism goal</strong>
      </>,
      <>
        Election volunteering, lobby days, and elected/issue accountability
        actions
      </>,
    ],
    icon: NewspaperIcon,
    color: "#664697 !important",
  },
  solidarity: {
    label: "Solidarity Now",
    value: "solidarity",
    description: [
      <>
        Activities in partnership with <strong>Solidarity Now</strong>
      </>,
      <>
        Some Solidarity Now activities will count towards {currentYear} member
        political volunteer goals
      </>,
    ],
    icon: HandshakeIcon,
    color: "#72a3d2 !important",
  },
  member: {
    label: "Member Mobilization",
    value: "member",
    description: [
      <>Internal engagement data for union-wide coordinated actions</>,
      <>
        Reporting on member turnout to movement activities like{" "}
        <strong>No Kings, ICE Out, or May Day</strong>
      </>,
    ],
    icon: Diversity2Icon,
    color: "#0a700ab3 !important",
  },
};
